// Auth
export const LOGGED = 'LOGGED';
export const SET_USER = 'SET_USER';
export const SET_ADS = 'SET_ADS';
export const SET_ACTIVITIES = 'SET_ACTIVITIES';
export const CLOSE_ACTIVITY = 'CLOSE_ACTIVITY';
export const SET_SHOPS = 'SET_SHOPS';
export const ADD_SHOP = 'ADD_SHOP';
export const LOAD_MORE_SHOPS = 'LOAD_MORE_SHOPS';
export const SET_CART_DATA = 'SET_CART_DATA';
export const ADD_CART_LOCATION = 'ADD_CART_LOCATION';
export const PUT_CART_LOCATION = 'PUT_CART_LOCATION';
export const PUT_CART_LOCATION_PRODUCTS = 'PUT_CART_LOCATION_PRODUCTS';
export const SORT_CART_LOCATIONS = 'SORT_CART_LOCATIONS';
export const DELETE_CART_LOCATION_BY_KEY = 'DELETE_CART_LOCATION_BY_KEY';
export const PUT_CART_LAST_LOCATION = 'PUT_CART_LAST_LOCATION';
export const LOAD_LOCAL_STORAGE_CART = 'LOAD_LOCAL_STORAGE_CART';
export const INIT_CART = 'INIT_CART';
export const SAVE_LOCAL_STORAGE_CART = 'SAVE_LOCAL_STORAGE_CART';
export const SET_COUPONS = 'SET_COUPONS';
export const SET_USED_COUPONS = 'SET_USED_COUPONS';
export const LOAD_MORE_USED_COUPONS = 'LOAD_MORE_USED_COUPONS';
export const SET_EXPIRED_COUPONS = 'SET_EXPIRED_COUPONS';
export const LOAD_MORE_EXPIRED_COUPONS = 'LOAD_MORE_EXPIRED_COUPONS';
export const ADD_COUPON = 'ADD_COUPON';
export const INIT_TRIAL = 'INIT_TRIAL';
export const TRIAL_CALCULATE = 'TRIAL_CALCULATE';
export const SET_CART_COUPON = 'SET_CART_COUPON';
export const SET_AGREEMENTS = 'SET_AGREEMENTS';
export const SET_HISTORY_ORDERS = 'GET_HISTORY_ORDERS';
export const LOAD_MORE_HISTORY = 'LOAD_MORE_HISTORY';
export const SET_PROCESSING_ORDERS = 'GET_PROCESSING_ORDERS';
export const LOAD_MORE_PROCESSING = 'LOAD_MORE_PROCESSING';
export const SET_ORDER = 'SET_ORDER';
export const DELETE_ORDER = 'DELETE_ORDER';
export const SET_CART_ID = 'SET_CART_ID';
export const CLEAR_CART_ID = 'CLEAR_CART_ID';
export const SET_ADDRESSES = 'SET_ADDRESSES';
export const SET_DEFAULT_ADDRESS = 'SET_DEFAULT_ADDRESS';
export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const SET_ADDRESS = 'SET_ADDRESS';
export const INIT_CART_LAST_LOCATION = 'INIT_CART_LAST_LOCATION';
export const SET_DEFAULT_AGREEMENT = 'SET_DEFAULT_AGREEMENT';
export const DELETE_AGREEMENT = 'DELETE_AGREEMENT';
export const SET_DEFAULT_CASH = 'SET_DEFAULT_CASH';
export const SET_SYSTEMP_PARAMETER = 'SET_SYSTEMP_PARAMETER';
export const SET_CAN_ORDER = 'SET_CAN_ORDER';
export const SET_CART_LOCATIONS = 'SET_CART_LOCATIONS';
export const ADD_FAVORITE = 'ADD_FAVORITE';
export const DELETE_FAVORITE = 'DELETE_FAVORITE';
export const SET_MENUS = 'SET_MENUS';
export const SET_IS_LAUNCH = 'SET_IS_LAUNCH';
export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT';
export const SET_NOTICES = 'SET_NOTICES';
export const PUT_CART_PRODUCT = 'PUT_CART_PRODUCT';
export const DELETE_CART_PRODUCT = 'DELETE_CART_PRODUCT';
export const SET_SOCKET_STATE = 'set_socket_state';
export const SET_DRIVER_IDS = 'set_driver_ids';
export const SET_BLOCK_IDS = 'set_block_ids';
export const SET_CONFIRM_DRIVER = 'SET_CONFIRM_DRIVER';
export const SET_DRIVER = 'SET_DRIVER';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_UNREAD_MESSAGES = 'SET_UNREAD_MESSAGES';

// LINE
export const SET_LINE_BOT_ID = 'SET_LINE_BOT_ID';
export const SET_IS_LINE_MINI = 'SET_IS_LINE_MINI';
